import ClassNames from "classnames";
import { FunctionComponent, MouseEvent } from "react";
import { ColorScheme, IconName, Language } from "../types/index.js";
import { css } from "../utils/emotion.js";
import { getTranslations } from "../utils/utils.js";
import Icon from "./Icon.js";

interface Props {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  scheme: ColorScheme;
  className: string;
  iconClassName: string;
  direction: "left" | "right";
  transparentBackground: boolean;
  languageId: Language;
  glyph?: IconName;
}

const translations = {
  de: { prev: "vorherigen Inhalt anzeigen", next: "nächsten Inhalt anzeigen" },
  it: {
    prev: "mostrare contenuto precedente",
    next: "mostrare contenuto successivo",
  },
  en: { prev: "show previous content", next: "show next content" },
  fr: {
    prev: "afficher le contenu précédent",
    next: "afficher le contenu suivant",
  },
};

const SliderArrow: FunctionComponent<Props> = ({
  onClick,
  scheme,
  direction,
  className,
  iconClassName,
  transparentBackground,
  languageId,
  glyph,
}) => {
  const i18n = getTranslations(languageId, translations);

  return (
    <button
      className={ClassNames(
        className,
        css({
          background: transparentBackground
            ? "transparent"
            : scheme.primary.background,
          fill: scheme.primary.text,
        }),
      )}
      onClick={onClick}
      aria-label={direction === "left" ? i18n.prev : i18n.next}
    >
      <Icon
        className={iconClassName}
        glyph={glyph ?? (direction === "left" ? "arrow-left" : "arrow-right")}
      />
    </button>
  );
};

export default SliderArrow;
